import { formatCurrency } from './formatNumber';

const formatPricePerUnit = (salePrice, unit) => {
  if (!salePrice || !unit) return undefined;
  const formattedCurrency = formatCurrency(salePrice);
  return formattedCurrency ? `${formattedCurrency} / ${unit}` : undefined;
};

export default formatPricePerUnit;
